import React, { useState, Fragment, useEffect } from "react";
import HorizontalSidePanel from "./../../components/UI/panel/HorizontalSidePanel";
import classes from "./MapContainer.module.css";
import VerticalSidePanel from "./../../components/UI/panel/VerticalSidePanel";
import Horizontal from "../../components/forms/horizontal/Horizontal";
import Vertical from "../../components/forms/vertical/Vertical";
import SmallGraph from "../../components/forms/horizontal/SmallFastGraph/SmallGraph";
import { useLocation } from "react-router-dom";

let listener = null;
const MapContainer = (props) => {
  const [showInfoPanel, setShowInfoPanel] = useState(false);
  const { search } = useLocation();

  const close = () => {
    setShowInfoPanel(false);
  };

  const showAnimation = (value) => {
    if (showInfoPanel && value) {
      clearTimeout(listener);
      setShowInfoPanel(false);
      listener = setTimeout(() => setShowInfoPanel(true), 250);
    } else {
      setShowInfoPanel(true);
    }
  };

  useEffect(() => {
    return () => clearTimeout(listener);
  }, []);

  const [baseBtnName, setBaseBtnName] = useState([]);

  useEffect(() => {
    if (new URLSearchParams(search).get("typeId") === "9")
      setBaseBtnName([classes.category_bins]);
    else if (new URLSearchParams(search).get("typeId") === "1")
      setBaseBtnName([classes.category_envi]);
  }, [search]);

  console.log(baseBtnName);

  return (
    <Fragment>
      <HorizontalSidePanel className={baseBtnName.join(" ")}>
        <Horizontal showAnimation={showAnimation} close={close} />
      </HorizontalSidePanel>
      {(new URLSearchParams(search).get("typeId") === "9" ||
        new URLSearchParams(search).get("typeId") === "1") && (
        <HorizontalSidePanel className={classes.statistcs_btn} open={false}>
          <>
            <SmallGraph
              typeId={new URLSearchParams(search).get("typeId")}
              loop={[
                "Θερμοκρασία αέρα",
                "Σωματίδια σκόνης PM1",
                "Σωματίδια σκόνης PM10",
              ]}
            />
          </>
        </HorizontalSidePanel>
      )}

      <VerticalSidePanel show={showInfoPanel} close={close}>
        <Vertical />
      </VerticalSidePanel>
      <div className={props.mapFrame ? classes.wrapper_full : classes.wrapper}>
        {React.cloneElement(props.children, {
          showAnimation,
        })}
      </div>
    </Fragment>
  );
};

export default MapContainer;
